/* eslint-disable */
export default function init(Blockly, profile) {
    Blockly.Arduino.texts = {};
    Blockly.Arduino.text = function() {
        return ["String(" + Blockly.Arduino.quote_(this.getFieldValue("TEXT")) + ")", Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.text_format = function() {
        var a = this.getFieldValue("FORMAT");
        return ["String((long)" + (Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC) || "0") + "," + a + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_tonumber = function() {
        return ["String(" + (Blockly.Arduino.valueToCode(this, "TXT", Blockly.Arduino.ORDER_ATOMIC) || "") + ").toFloat()", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_format_decimal = function() {
        var a = this.getFieldValue("DECIMALS");
        return ["String(" + (Blockly.Arduino.valueToCode(this, "NUM", Blockly.Arduino.ORDER_ATOMIC) || "0") + "," + a + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_join = function(a) {
        for (var b = "", c = 0; c < a.itemCount_; c++) {
            var d = Blockly.Arduino.valueToCode(a, "ADD" + c, Blockly.Arduino.ORDER_ATOMIC) || "";
            "" != d && ("" != b && (b += "+"), b = d.startsWith("String(") ? b + d : b + ("String(" + d + ")"))
        }
        return [b, Blockly.Arduino.ORDER_ATOMIC]
    };
    Blockly.Arduino.text_length = function(a) {
        return ["String(" + (Blockly.Arduino.valueToCode(a, "VALUE", Blockly.Arduino.ORDER_ATOMIC) || '""') + ").length()", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_compare = function(a) {
        var b = Blockly.Arduino.valueToCode(a, "TEXT1", Blockly.Arduino.ORDER_ATOMIC) || '""';
        a = Blockly.Arduino.valueToCode(a, "TEXT2", Blockly.Arduino.ORDER_ATOMIC) || '""';
        var c = this.getFieldValue("TYPE"),
            d = "";
        "equals" == c && (d = "String(" + b + ").equals(" + a + ")");
        "equalsignore" == c && (d = "String(" + b + ").equalsIgnoreCase(" + a + ")");
        "notequals" == c && (d = "(!String(" + b + ").equals(" + a + "))");
        "startswith" == c && (d = "String(" + b + ").startsWith(" + a + ")");
        "endswith" == c && (d = "String(" + b + ").endsWith(" + a + ")");
        return [d, Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_indexof = function(a) {
        var b = Blockly.Arduino.valueToCode(a, "TEXT1", Blockly.Arduino.ORDER_ATOMIC) || '""';
        a = Blockly.Arduino.valueToCode(a, "TEXT2", Blockly.Arduino.ORDER_ATOMIC) || '""';
        var c = this.getFieldValue("TYPE"),
            d = "";
        "indexof" == c && (d = "(String(" + b + ").indexOf(" + a + ")+1)");
        "lastindexof" == c && (d = "(String(" + b + ").lastIndexOf(" + a + ")+1)");
        return [d, Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_replace = function(a) {
        var b = Blockly.Arduino.nameDB_.getName(
            this.getFieldValue("VARTEXT"),
            Blockly.VARIABLE_CATEGORY_NAME);
        var c = Blockly.Arduino.valueToCode(a, "TEXT2", Blockly.Arduino.ORDER_ATOMIC) || '""';
        a = Blockly.Arduino.valueToCode(a, "TEXT3", Blockly.Arduino.ORDER_ATOMIC) || '""';
        return "" + b + ".replace(" + c + "," + a + ");\n"
    };
    Blockly.Arduino.text_contains = function(a) {
        var b = Blockly.Arduino.valueToCode(a, "TEXT1", Blockly.Arduino.ORDER_ATOMIC) || '""';
        a = Blockly.Arduino.valueToCode(a, "TEXT2", Blockly.Arduino.ORDER_ATOMIC) || '""';
        return ["(String(" + b + ").indexOf(" + a + ")!=-1)", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_substring = function(a) {
        a = Blockly.Arduino.valueToCode(a, "TEXT1", Blockly.Arduino.ORDER_ATOMIC) || '""';
        var b = Blockly.Arduino.valueToCode(this, "START", Blockly.Arduino.ORDER_ATOMIC) || "0",
            c = Blockly.Arduino.valueToCode(this, "END", Blockly.Arduino.ORDER_ATOMIC) || "0";
        return ["String(" + a + ").substring((" + b + ")-1," + c + ")", Blockly.Arduino.ORDER_UNARY_POSTFIX]
    };
    Blockly.Arduino.text_ascii = function(a) {
        return ["('" + this.getFieldValue("CHAR") + "')", Blockly.Arduino.ORDER_ATOMIC]
    };
}